import React from "react";

const Services = () => {
  return (
    <>
      {/* Service Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Services
            </h6>
            <h1 className="mb-5">Our Services</h1>
          </div>
          <div className="row g-4">
            {[
              {
                icon: "fa-briefcase",
                title: "Overseas Recruitment",
                desc: "Opportunities in Gulf countries and worldwide.",
              },
              {
                icon: "fa-users",
                title: "Manpower Supply",
                desc: "Skilled and unskilled workforce for all industries.",
              },
              {
                icon: "fa-building",
                title: "Employer Staffing",
                desc: "Reliable and pre-screened candidates for companies.",
              },
              {
                icon: "fa-id-card",
                title: "Visa & Documentation",
                desc: "Complete support for visa and employment documents.",
              },
              {
                icon: "fa-plane",
                title: "Ticketing",
                desc: "Air ticket booking for international travel.",
              },
              {
                icon: "fa-user-tie",
                title: "HR Consultancy",
                desc: "Professional HR and recruitment consulting services.",
              },
            ].map((service, index) => (
              /* Changed col-lg-3 to col-lg-4 for a 3-column desktop grid */
              <div
                className="col-lg-4 col-sm-6 wow fadeInUp"
                key={index}
                data-wow-delay={`${0.1 * (index % 3)}s`}
              >
                <div className="service-item rounded pt-3 h-100">
                  <div className="p-4 text-center">
                    <i
                      className={`fa fa-3x ${service.icon} text-primary mb-4`}
                    />
                    <h5>{service.title}</h5>
                    <p>{service.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
